import { IndexedDBService } from "../../../maino-db/";

const dbService = new IndexedDBService('trakingMenu', 1, 'data');

const dbTrakingMenu = async ()=>{
  await dbService.openDatabase();
  return dbService;
}

export { dbTrakingMenu }
